import React from 'react';
import { CATALOG_STATUS_ACTIVE } from '../../utils/statuses/catalogStatus';
import DataPlate from '../DataPlate/DataPlate';
import styles from './CatalogStatus.module.scss';
import type { Catalog } from '../../entities/Catalog';

function CatalogStatus({ catalog }: { catalog: Catalog }) {
  return (
    !!catalog?.catalogStatus &&
    catalog.catalogStatus !== CATALOG_STATUS_ACTIVE && (
      <DataPlate className={styles.status}>{catalog.catalogStatus}</DataPlate>
    )
  );
}

export default CatalogStatus;
